
import Header from "@/components/header/header.vue";
import {inject, shallowRef,ref} from 'vue'
import { useRoute } from 'vue-router';
export default {
  components: {
    Header,
  },
  setup(){
    const route:any = useRoute();
    const $http: any = inject("$http");
    let datas = shallowRef({})
    let title = ref('Help')
    const $store: any = inject("$store");
    let id = route.params.id
    let is_app =ref($store.getIsApp()) 
    
    const is_hide_header = ref(false)
    if(route.query.hide_header === '1') {
      is_hide_header.value = true
    }

    if(id == null && route.fullPath.indexOf('/policy') != -1){
      id = 2126
    }  
    if(id == 2126){
        title.value = 'Privacy Policy'
    }
   
    $http.get_article_detail({ id: id}).then((res:any)=>{
        console.log(res);
        if(res.code === 200){
          datas.value = res.data
        }
    })

    return {
      datas,
      title,
      is_hide_header
    }
  }
}
